<template>
  <div>
    <el-dialog
      :visible="isOpen"
      :show-close="true"
      :append-to-body="true"
      :before-close="cancel"
      title="请选择事件资产"
      custom-class="table-box-dialog"
      top="10vh"
    >
      <div>
        <div v-if="app_name" style="padding-bottom: 20px;">
          <el-page-header :content="app_name" @back="goBack" />
        </div>
        <div>
          <el-input
            v-if="app_name"
            v-model="search_name"
            size="mini"
            style="width: 150px"
          />

          <el-button
            class="fr"
            style="margin-bottom: 10px"
            size="mini"
            type="primary"
            :loading="pull_loading"
            @click="pull"
          >同步</el-button>
        </div>

        <!-- 事件表格 -->
        <app-table
          ref="my_table"
          v-loading="asset_table_loading"
          :table-key="table_key"
          :tablep="asset_tablep"
          :table-props="{
            'height': '400px'
          }"
          :search="search_name"
          :get-data="getTableData"
          :table-list-data="table_list_data"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import EventManager from '@/api/tool/event-manager/jrtt';
const eventManager = new EventManager();

import AppManagement from '@/api/tool/app-management/jrtt';
const appManagement = new AppManagement();

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    tablep: {
      type: Object,
      default: () => {
        return {
          params: {
            page: 1,
            limit: 10,
          },
        };
      },
    },
  },
  data() {
    return {
      event_data: {
        list: [],
        page_info: {
          total_number: 0,
          page: 1,
          page_size: 10,
          total_page: 4,
        },
      },
      app_name: '', // 应用名称
      package_name: '', // 包名
      search_name: '', // 搜索名称
      table_list_data: {},
      asset_table_loading: false,
      select_table_list: [],
      asset_tablep: {},
      // 事件资产
      assets_list: {
        options: [],
        on: {
          change: (val) => {
            this.asset_tablep.asset_id = val.asset_id;
            this.asset_tablep.channel_ids = this.channel_package_list.value;

            this.getChannelPackageList({
              advertiser_id: this.tablep.advertiser_id,
              package_id: val.package_id,
            });
          },
        },
        value: {
          asset_id: '',
          package_id: '',
        },
      },
      // 渠道包列表
      channel_package_list: {
        options: [],
        on: {
          change: (val) => {
            this.asset_tablep.channel_ids = val;
            if (this.$refs.my_table) {
              this.$refs.my_table.seekTable();
            }
          },
        },
        value: [],
      },
      // 优化目标列表
      external_action_list: {
        options: [],
        on: {
          change: (val) => {
            this.asset_tablep.external_action = val;
            this.$refs.my_table.seekTable();
          },
        },
        value: [],
      },
      table_key: [],
      asset_table_key: [{
        name: '资产名称（应用名称）',
        value: 'asset_name',
        width: '150px',
      },
      {
        name: '应用包名',
        value: 'package_name',
        width: '200px',
      },
      {
        name: '下载链接',
        value: 'download_url',
      },
      {
        name: '操作',
        value: 'id',
        format: (row) => {
          const h = this.$createElement;
          const ele = h('div',
            null, [
              h('el-button',
                {
                  props: {
                    size: 'mini',
                    type: 'success',
                  },
                  on: {
                    click: () => {
                      this.$emit('confirm', row);
                    },
                  },
                },
                '选择该应用包'
              ),
              h('el-button',
                {
                  props: {
                    size: 'mini',
                    type: 'primary',
                  },
                  on: {
                    click: () => {
                      if (!row.package_id) {
                        this.$message.warning('没有分包');
                        return;
                      }

                      this.app_name = row.name;
                      this.package_name = row.package_name;
                      this.asset_tablep = {
                        advertiser_id: this.tablep.advertiser_id,
                        package_id: row.package_id,
                      };

                      this.getChannelPackageList(this.asset_tablep).then(() => {
                        this.$nextTick(() => {
                          this.table_key = this.channel_table_key;
                          this.$refs.my_table.seekTable();
                        });
                      });
                    },
                  },
                },
                '选择分包'
              ),
            ]);
          return ele;
        },
      }],

      channel_table_key: [{
        name: '资产名称（应用名称）',
        value: 'name',
        width: '150px',
      },
      {
        name: '应用包名',
        value: 'package_name',
        width: '200px',
      },
      {
        name: '下载链接',
        value: 'download_url',
      },
      {
        name: '操作',
        value: 'id',
        format: (row) => {
          const h = this.$createElement;
          const ele = h('div',
            null, [
              h('el-button',
                {
                  props: {
                    size: 'mini',
                    type: 'success',
                  },
                  on: {
                    click: () => {
                      row.package_name = this.package_name;
                      this.$emit('confirm', row);
                    },
                  },
                },
                '选择'
              ),
            ]);
          return ele;
        },
      }],

      pull_loading: false,
      // app类型枚举值
      app_type_enum: {
        'APP_ANDROID': 'ANDROID',
        'APP_IOS': 'IOS',
      },
      deep_bid_type_data: {
        options: [],
        value: '',
      },
    };
  },
  created(){
    this.asset_tablep = {
      advertiser_id: this.tablep.advertiser_id,
      asset_type: this.tablep.landing_type,
      app_type: this.tablep.app_type,
    };

    this.table_key = this.asset_table_key;
    this.getTableData = this.getAssetsList;
  },
  methods: {
    // 获取深度出价枚举值
    getDeepBidEnum(key) {
      const enum_list = this.$store.getters.jrttEnum[key];
      const enum_obj = {};
      for (let i = 0; i < enum_list.length; i++) {
        const item = enum_list[i];
        enum_obj[item.value] = {
          label: item.label,
          list: [],
          disabled: true,
        };
      }
      return enum_obj;
    },

    getTableData: () => {},

    goBack() {
      this.asset_table_loading = true;
      this.asset_tablep = {
        advertiser_id: this.tablep.advertiser_id,
        asset_type: this.tablep.landing_type,
        app_type: this.tablep.app_type,
      };
      this.app_name = '';
      this.search_name = '';
      this.table_list_data = undefined;
      this.table_key = this.asset_table_key;
      this.getTableData = this.getAssetsList;

      this.$nextTick(() => {
        this.asset_table_loading = false;
        this.$refs.my_table.seekTable();
      });
    },
    // 勾选行回调
    tableSelectTr(row) {
      this.select_table_list = row;
    },
    // 同步
    pull() {
      const s = this;
      s.pull_loading = true;
      this.pullEventAssets({
        advertiser_id: this.tablep.advertiser_id,
        asset_type: this.asset_tablep.asset_type,
        landing_type: this.tablep.landing_type,
      }).then((res) => {
        s.pull_loading = false;
        s.$message({
          message: res.message,
          type: 'success',
        });

        this.getAssetsList({
          advertiser_id: this.tablep.advertiser_id,
          asset_type: this.tablep.landing_type,
          app_type: this.app_type_enum[this.tablep.app_type],
        });

        this.assets_list.value.asset_id = '';
        this.asset_tablep.asset_id = '';
      }).catch(() => {
        s.pull_loading = false;
      });
    },
    // 获取资产列表
    getAssetsList(params) {
      return new Promise((resolve, reject) => {
        eventManager
          .getAssetsListApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取渠道包列表
    getChannelPackageList(params) {
      this.getTableData = null;
      this.search_name = '';
      this.asset_table_loading = true;
      return new Promise((resolve, reject) => {
        appManagement
          .getChannelPackageListApi(params)
          .then((response) => {
            this.table_list_data = {
              list: response.list,
              page_info: {
                page: 1,
                page_size: 10,
                total_number: response.list.length,
              },
            };
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          }).finally(() => {
            this.asset_table_loading = false;
          });
      });
    },

    // 同步事件资产
    pullEventAssets(params) {
      return new Promise((resolve, reject) => {
        eventManager
          .pullEventAssetsApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 取消
    cancel() {
      this.$emit('cancel');
    },
    // 提交
    confirm() {
      const data = this.select_table_list;
      const check_index_list = this.deep_bid_type_data.options[this.deep_bid_type_data.value].list.map(item => item.index);
      this.$emit('confirm', data, this.tableBoxKey, check_index_list);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .table-box-dialog {
  width: auto;
  min-width: 815px;
  max-width: 1000px;
  .text-tips {
    color: red;
    line-height: 50px;
  }
  .material-container {
    .material-cord {
      min-height: 286px;
      position: relative;
      .constituency {
        overflow-y: scroll;
        height: 400px;
        width: 100%;
        ul {
          margin: 0;
          padding: 0;
          li {
            position: relative;
            list-style: none;
            border: 0;
            width: 245px;
            margin-top: 16px;
            margin-right: 12px;
            display: inline-block;
            background-color: #ccc;
            .item .img-show img {
              max-width: 100%;
              max-height: 100%;
            }
          }
          li:nth-child(4n) {
            margin-right: 0;
          }
        }
      }
    }
  }
  .title-list-box {
    height: 375px;
    overflow: auto;
    ul {
      padding: 0;
      li {
        list-style-type: none;
        .title-index {
          display: block;
          float: left;
          width: 36px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          background-color: #edf1f5;
        }
        .title-wrong {
          background-color: red;
          color: #edf1f5;
        }
        .title-input {
          width: 982px;

          input {
            width: 95%;
            height: 36px;
            border: none;
            background: transparent;
          }
        }
        .input-action {
          background-color: #edf1f5;
        }
      }
    }
  }
  .f-left {
    float: left;
  }
  .f-right {
    float: right;
  }
  .label-border {
    width: 140px;
    height: 32px;
    line-height: 32px;
    border-radius: 4px;
    text-align: center;
    border: 1px #dcdee2 solid;
  }
  .el-upload {
    width: 100%;
  }
  .el-upload-dragger {
    width: 100%;
  }
  .el-dialog__footer {
    border-top: 1px #d9d9d9 solid;
    padding: 15px 20px;
  }
  .dialog-footer {
    height: 54px;
    line-height: 54px;
    .thumb-img {
      float: left;
      width: 690px;
      height: 63px;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      margin-left: 50px;
      text-align: left;
      .item {
        width: 95px;
        height: 54px;
        display: inline-block;
        text-align: center;
        border: 1px #aaa solid;
        margin: 0 10px;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }
}
</style>
